/**
 * @implements ImportSourceDataType
 * @type CanvasAssignmentType
 */
export const CanvasAssignmentType = {
    name: 'entry',
    sourceName: 'Course Assignments',
};
